














































import './KisweButton.scss'
import { defineComponent, ref, toRef, watch } from '@vue/composition-api'
import { useShapes, useSizes, useThemes } from '../../../compositions'
import KisweIcon from '../../KisweIcon'
import { sleep } from '@/modules/common/utils'

export default defineComponent({
  name: 'KisweButton',
  components: {
    KisweIcon
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String as () => 'button'|'reset'|'submit',
      required: false,
      default: 'button',
      validator: (value: string) => ['button', 'reset', 'submit'].includes(value)
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isBlinking: {
      type: Boolean,
      required: false,
      default: false
    },
    isLabelEditable: {
      type: Boolean,
      required: false,
      default: false
    },
    inputMaxLen: {
      type: Number,
      required: false,
      default: 10
    },
    initialLabel: {
      type: String,
      required: false,
      default: ''
    },
    ...useThemes().props,
    ...useShapes().props,
    ...useSizes().props
  },
  emits: {
    click (_e: MouseEvent) { return true },
    labelChanged (_label: string) { return true }, // FIXME: does not belong here => emit dblclick and move logic up
    mouseup (_e: MouseEvent) { return true },
    mousedown (_e: MouseEvent) { return true },
    mouseover (_e: MouseEvent) { return true },
    mouseleave (_e: MouseEvent) { return true }
  },
  setup (props) {
    const isEditing = ref(false)
    const initialLabel = toRef(props, 'initialLabel')
    const label = ref(initialLabel.value)
    // Added the following condition to not create watchers if not needed. Updates to isLabelEditable after initial
    // setup is therefore not recognized. This is an optimization compromise.
    if (props.isLabelEditable) watch(initialLabel, (newValue) => { label.value = newValue })

    return {
      isEditing,
      label
    }
  },
  methods: {
    async click (e: MouseEvent) {
      if (this.isLabelEditable) {
        await sleep(250)
        if (this.isEditing) return
      }
      this.$emit('click', e)
    },
    doubleClick () {
      if (this.isLabelEditable) {
        this.isEditing = true
        this.$nextTick(() => {
          //@ts-ignore
          this.$refs.labelInput.focus()
        })
      }
    },
    editDone () {
      if (this.isEditing) {
        this.isEditing = false
        const newLabel = this.label.trim()
        if (newLabel !== this.initialLabel) this.$emit('labelChanged', newLabel)
        if (!newLabel) this.label = this.initialLabel
      }
    },
    mouseup (e: MouseEvent) {
      this.$emit('mouseup', e)
    },
    mousedown (e: MouseEvent) {
      this.$emit('mousedown', e)
    },
    mouseover (e: MouseEvent) {
      this.$emit('mouseover', e)
    },
    mouseleave (e: MouseEvent) {
      this.$emit('mouseleave', e)
    },
    selectAllText () {
      //@ts-ignore
      this.$refs.labelInput.select()
    }
  }
})
